import { formatNumber, type Locale } from '@qm/i18n';
import type { BadgeTone } from '@qm/ui/kit';
import type { OpportunityStatus } from '@qm/contracts/opportunities';

export const STATUS_TONE: Record<OpportunityStatus, BadgeTone> = {
  draft: 'neutral', submitted: 'info', quoted: 'warning', negotiating: 'warning', pending_approval: 'warning', approved: 'info', accepted: 'success', rejected: 'danger',
};

export const fmtMoney = (locale: Locale, currency: string, minor: number | null | undefined) =>
  minor === null || minor === undefined ? '—' : formatNumber(locale, minor / 100, { style: 'currency', currency, minimumFractionDigits: 2 });
/** "12,500.50" typed by a person -> minor units; null when empty or not a non-negative number. */
export const toMinor = (v: string): number | null => {
  const n = Number(v.replace(/[,\s]/g, ''));
  return v.trim() === '' || !Number.isFinite(n) || n < 0 ? null : Math.round(n * 100);
};
export const pct = (bps: number) => `${(bps / 100).toFixed(2).replace(/\.?0+$/, '')}%`;
